import { Column } from '@/presentation/components/table';
import { AiFillFilePdf } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { CollectionBase } from '../types/collections';

export const columns: Column<CollectionBase>[] = [
  { header: 'Título', accessor: 'title' },
  {
    header: 'Descripción',
    accessor: 'description',
    render: (value) => {
      if (value && typeof value === 'string') {
        return (
          <span className="text-sm truncate block max-w-[400px]">{value}</span>
        );
      }
      return <span className="text-sm">No hay descripción</span>;
    },
  },
  {
    header: 'Creado el',
    accessor: 'createdAt',
    render: (value) => {
      if (value && typeof value === 'object' && 'seconds' in value) {
        return (
          <span className="text-sm">
            {new Date(value.seconds! * 1000).toLocaleDateString('es-CO', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </span>
        );
      }
      return <span className="text-sm">Desconocido</span>;
    },
  },
  {
    header: 'Vistas',
    accessor: 'views',
    render: (value) => (
      <div className="flex justify-center items-center">
        <span className="text-sm">
          {value && typeof value === 'number' ? value : 0}
        </span>
      </div>
    ),
  },
  {
    header: 'Descargas',
    accessor: 'downloads',
    render: (value) => (
      <div className="flex justify-center items-center">
        <span className="text-sm">
          {value && typeof value === 'number' ? value : 0}
        </span>
      </div>
    ),
  },
  {
    header: 'Favoritos',
    accessor: 'favorites',
    render: (value) => (
      <div className="flex justify-center items-center">
        <span className="text-sm">
          {value && typeof value === 'number' ? value : 0}
        </span>
      </div>
    ),
  },
  {
    header: 'Comentarios',
    accessor: 'comments',
    render: (value) => (
      <div className="flex justify-center items-center">
        <span className="text-sm">
          {value && typeof value === 'number' ? value : 0}
        </span>
      </div>
    ),
  },
  {
    header: 'Documento',
    accessor: 'documentUrl',
    render: (value) =>
      value ? (
        <Link to={value.toString()} target="_blank" rel="noreferrer">
          <div className="flex justify-center items-center">
            <AiFillFilePdf className="text-red-500" size={24} />
          </div>
        </Link>
      ) : (
        <div className="flex justify-center items-center">
          <AiFillFilePdf className="text-gray-500" size={24} />
        </div>
      ),
  },
];
